export interface File {
  /**
   * Name of file
   */
  name: string | null

  /**
   * Path to file
   */
  path: string | null

  /**
   * Size of file
   */
  size: number
}

/**
 * Down sample status of the inspection area
 */
export enum FileProcessingStatus {
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  RUNNING = 'RUNNING',
}
